require("./threepl-services-table-skeleton-row.scss");

import {ChangeDetectionStrategy, Component, computed, input} from "@angular/core";
import {ThreePLServicesTableDynamicColumn} from "../threepl-services-table/threepl-services-table.component";
import {THREE_PL_SERVICES_SKELETON_CELLS} from "../../constants/threepl-services.constant";

@Component({
  selector: "app-threepl-services-table-skeleton-row",
  templateUrl: "./threepl-services-table-skeleton-row.html",
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {"class": "tr", "aria-busy": "true"},
})
export class ThreeplServicesTableSkeletonRowComponent {
  readonly columns = input<Record<string, boolean>>({});
  readonly dynamicColumns = input<ThreePLServicesTableDynamicColumn[]>([]);

  readonly cells = computed(() => [
    ...THREE_PL_SERVICES_SKELETON_CELLS.filter((cell) => !cell.column || this.columns()?.[cell.column]).map((cell) => ({cls: cell.cls, lines: cell.lines === 2})),
    ...this.dynamicColumns().map((column) => ({cls: column.cls, lines: false})),
  ]);
}
